import React, { useState } from 'react'
import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Card,
  DatePicker,
  Select,
  Upload,
  message,
  Spin
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import UploadOutlined from '@ant-design/icons/lib/icons/UploadOutlined'
import ds from '../../../Services/DataServices'
import { IntlProvider } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck
} from '../../../appRedux/actions/GlobalMethods'
import { PRICEBOOK } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const AddPriceBook = ({ match }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const store = useStore()
  const [form] = Form.useForm()
  const [getOutletData, setOutletData] = React.useState([])
  const [getCustomersData, setCustomersData] = React.useState([])
  const [isSpinningLoading, setSpinningLoading] = React.useState(true)
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  //const [getDefaultOut, setDefaultOut] = React.useState('Select Outlet');
  //const [getDefaultCus, setDefaultCus] = React.useState('');

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  React.useEffect(() => {
    dispatch(setCommonConfigs(PRICEBOOK))
    getAddBookData()
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  async function getAddBookData () {
    const getAddBookData = ds.getPriceBookData({}, BEHAVIOUR_TYPE.GET)
    // ;
    await getAddBookData
      .then(res => {
        setSpinningLoading(false)
        if (res.data.data.outlets || res.data.data.customers) {
          let outMapped = res.data.data.outlets.map(obj => {
            return {
              outID: obj.outletID,
              outName: obj.outletName
            }
          })
          let cusMapped = res.data.data.customers.map(obj => {
            return {
              cusID: obj.customerID,
              cusName: obj.customerGroupName
            }
          })
          //let defaultOut = outMapped.filter(x => x.outID === 0) > 0 ? outMapped.filter(x => x.outID === 0)[0].outName : outMapped[0].outName;
          //let defaultCus = cusMapped.filter(x => x.cusID === 0) > 0 ? cusMapped.filter(x => x.cusID === 0)[0].outName : cusMapped[0].cusName;
          setOutletData(outMapped)
          setCustomersData(cusMapped)
          //setDefaultOut(defaultOut);
          //setDefaultCus(defaultCus);
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setSpinningLoading(false)
      })
  }

  const props = {
    //name: 'file',
    //action: '',
    //headers: {
    //    authorization: 'authorization-text',
    //},
    onChange (info) {
      // ;
      //if (info.file.status !== 'uploading') {
      //    console.log(info.file, info.fileList);
      //}
      //if (info.file.status === 'done') {
      //    message.success(`${info.file.name} file uploaded successfully`);
      //} else if (info.file.status === 'error') {
      //    message.error(`${info.file.name} file upload failed.`);
      //}
      setTimeout(() => {
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList)
        }
        if (info.file.status === 'done') {
          message.success(`${info.file.name} file uploaded successfully`)
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} file upload failed.`)
        }
      }, 20000)
    }
  }

  const redirectToImport = () => {
    history.push('/dashboard/pricebook/import')
  }

  const formFields = () => {
    const children = []
    children.push(
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
       
          <Form.Item
            className='ant-form-item-label-custom ant-form-margin-right'
            name={`BookName`}
            label={<IntlMessages id='products.addpricebook.name' />}
            rules={[
              {
                required: true,
                message: (
                  <IntlMessages id='products.addpricebook.namerequired' />
                )
              }
            ]}
          >
            <Input placeholder='Book Name' />
          </Form.Item>
        
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        
          <Form.Item
            className='ant-form-item-label-custom'
            name={`ValidFrom`}
            label={<IntlMessages id='products.pricebook.validfrom' />}
          >
            <DatePicker
              className='gx-mb-3 gx-w-100'
              onChange={onChange}
              inputReadOnly={true}
            />
          </Form.Item>
        
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        
          <Form.Item
            className='ant-form-item-label-custom'
            name={`ValidTo`}
            label={<IntlMessages id='products.pricebook.validto' />}
          >
            <DatePicker
              className='gx-mb-3 gx-w-100'
              onChange={onChange}
              inputReadOnly={true}
            />
          </Form.Item>
        
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        
          <Form.Item
            className='ant-form-item-label-custom'
            name={`CustomerGroup`}
            label={<IntlMessages id='products.addpricebook.customergroup' />}
          >
            <Select
              defaultValue='All Customers'
              showSearch
              optionFilterProp='children'
            >
              {getCustomersData &&
                getCustomersData.map((e, key) => {
                  return (
                    <Select.Option key={key} value={e.cusID}>
                      {e.cusName}
                    </Select.Option>
                  )
                })}
            </Select>
          </Form.Item>
        
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        
          <Form.Item
            className='ant-form-item-label-custom'
            name={`Outlets`}
            label={<IntlMessages id='products.addpricebook.outlets' />}
          >
            <Select
              defaultValue='All Outlets'
              showSearch
              optionFilterProp='children'
            >
              {getOutletData &&
                getOutletData.map((e, key) => {
                  return (
                    <Select.Option key={key} value={e.outID}>
                      {e.outName}
                    </Select.Option>
                  )
                })}
            </Select>
          </Form.Item>
        
      </Col>,
      <Col lg={24} md={24} sm={24} xs={24}>

        <div className='display-margin-unset'>

          <Button onClick={() => { form.resetFields() }} type='primary' className='dk-btn-clear-field' size='large'>
          {<IntlMessages id='products.addpricebook.clear' />}
          </Button>

          <Button onClick={cancelBtn} type='primary' className='dk-btn-cancel' size='large'>
          {<IntlMessages id='products.addpricebook.cancel' />}
          </Button>

          <Button type='primary' htmlType='submit' className='dk-btn-add' size='large' disabled={getIsDisableCreate}>
          {<IntlMessages id='products.promoadd.savbtn' />}
          </Button>

          </div>

      </Col>,

    )

    return children
  }

  const onFinish = async values => {
    //;
    setSpinningLoading(true)
    let addUpdateDeletePriceBook = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }
    await ds
      .addUpdateDeletePriceBook(
        {
          Name: values.BookName,
          ValidFrom:
            values.ValidFrom && values.ValidFrom !== undefined
              ? values.ValidFrom.format()
              : undefined,
          ValidTo:
            values.ValidTo && values.ValidTo !== undefined
              ? values.ValidTo.format()
              : undefined,
          // ValidFrom:
          //   values.ValidFrom !== undefined
          //     ? values.ValidFrom.format("DD/MM/YYYY")
          //     : undefined,
          // ValidTo:
          //   values.ValidTo !== undefined
          //     ? values.ValidTo.format("DD/MM/YYYY")
          //     : undefined,
          CustomerGroupID: values.CustomerGroup,
          OutletID: values.Outlets,
          IsRemove: false,
          IsPricing: false
        },
        BEHAVIOUR_TYPE.POST
      )
      .then(response => (addUpdateDeletePriceBook.data = response.data))
      .catch(e => {
        setSpinningLoading(false)
        notAllowMsgCheck(e)
      })

    if (addUpdateDeletePriceBook.data.msgCode == 'GENERAL_SUCCESS') {
      //setSpinningLoading(false);
      message.success('Successfully Added ' + form.getFieldValue('BookName'))
      setTimeout(() => {
        let id = addUpdateDeletePriceBook.data.data
        history.push(`/dashboard/products/pricebook/customprices/${id}`)
      }, 2000)
    }

    if (addUpdateDeletePriceBook.data.msgCode == 'GENERAL_ERROR') {
      setSpinningLoading(false)
      message.error(addUpdateDeletePriceBook.data.msgDescription)
    }
    //setSpinningLoading(false);
  }

  function onChange (date, dateString) {
    //;
    //console.log(date, dateString);
  }

  function cancelBtn () {
    history.push('/Dashboard/products/pricebook')
  }

  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id='products.addeditpriceprod.savebook' />}
      spinning={isSpinningLoading}
      size='large'
    >
      <div className='Content-wrapper NewPriceBook-pg'>
       <div className="align-items-center bread-crum">
       <h3 className="mb-0 mr-3">
            <a
              onClick={() => history.push('/Dashboard/products/main')}
              className='custm-glinkprimaryclr'
            >
              {<IntlMessages id='products.addpricebook.products' />}
            </a>
          </h3>
          <i className="icon icon-charvlet-right mr-1 pt-1" />
          <h3 className="mb-0 mr-3">
            <a
              onClick={() => history.push('/Dashboard/products/pricebook')}
              className='custm-glinkprimaryclr'
            >
              {<IntlMessages id='products.addpricebook.pricebook' />}
            </a>
          </h3>
          <i className="icon icon-charvlet-right mr-1 pt-1" />
          <h3 className="mb-0 mr-3">
            <a>{<IntlMessages id='products.pricebook.newpricebook' />}</a>
          </h3>
        </div>

        <Card
          className='gx-card mt-3 Filters-wrapper No-BoxShadow'
          title={<IntlMessages id='products.pricebook.newpricebook' />}
        >
          <Form
            form={form}
            name='advanced_search'
            className='ant-advanced-search-form Filters-Form'
            onFinish={onFinish}
          >
            <Row>{formFields()}</Row>
            </Form>
        </Card>
      </div>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default AddPriceBook
